import Vue from 'vue'
import axios from 'axios/index'
import api from '../../api/api'

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  'USER_REQUEST': ({commit, dispatch}) => {
    commit('USER_REQUEST')
    axios({ url: 'user/profile', method: 'GET' })
      .then(resp => {
        commit('USER_SUCCESS', resp)
      })
      .catch(resp => {
        commit('USER_ERROR')
        // if resp is unauthorized, logout, to
        dispatch('AUTH_LOGOUT')
      })
  },
  updatePassword (context, user) {
    return api.updatePassword(user, function (data) {

    })
  }
}

const mutations = {
  'USER_REQUEST': (state) => {
    state.status = 'loading'
  },
  'USER_SUCCESS': (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  'USER_ERROR': (state) => {
    state.status = 'error'
  },
  'AUTH_LOGOUT': (state) => {
    state.profile = {}
  },
  updatePassword (state, options) {
    this.dispatch('updatePassword', options)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js